import { Component, Signal } from '@angular/core';
import { WebsiteStateService } from '../../state-management/services/website-state.service';
import { BusinessConfiguration } from '../../state-management/model/interfaces/state.model';
import { BusinessType } from '../../state-management/model/enums/state.enums';
import { Navbar } from '../../components/shared/navbar/navbar.component';
// import { StoreDataService } from '../../services/store-data.service';

@Component({
    selector: 'app-data-privacy',
    standalone: true,
    imports: [Navbar],
    templateUrl: './data-privacy.component.html',
    styleUrl: './data-privacy.component.scss'
})
export class DataPrivacyComponent {

  public metaData: Signal<BusinessConfiguration> = this.websiteState.configuration;
  public businessContactLabel: string = this.getLabelForBusinessType(this.getBusinessTypeFromString(this.metaData().legalData.businessType));
  
  constructor(
    private websiteState: WebsiteStateService
    // private storeDataService: StoreDataService
  ) { }

  ngOnInit() {
    // this.privacy = this.storeDataService.getImprint()
  }

  private getBusinessTypeFromString(value: string): BusinessType {
    if (Object.values(BusinessType).includes(value as BusinessType)) {
        return value as BusinessType;
    }
    return BusinessType.SelfEmployed; // Standardwert
  }

  private getLabelForBusinessType(businessType: BusinessType): string {
    switch (businessType) {
        case BusinessType.SelfEmployed:
            return 'Inhaber';
        case BusinessType.GbR:
        case BusinessType.UG:
        case BusinessType.GmbH:
            return 'Geschäftsführer';
        default:
            return 'Unternehmensvertreter'; 
    }
  }

}
